import { useQuery } from '@tanstack/react-query'

import { getOrganizationPayments } from '@src/api'
import { DefaultApiGetOrganizationPaymentsRequest } from '@src/api/generated/user-api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchOrganizationPayments = (
  params: DefaultApiGetOrganizationPaymentsRequest
) => {
  const { axiosInstance } = useAxios()

  return useQuery({
    enabled: !!params.organizationId,
    queryFn: () => getOrganizationPayments(axiosInstance, params),
    queryKey: [
      REACT_QUERY_CACHE_KEYS.GET_ORGANIZATION_PAYMENTS,
      params.organizationId,
    ],
  })
}
